import { useGT } from 'gt-react';
import { READINESS_STATES, type ReadinessState } from '@erp/shared-utils';
import type { MultiSelectOption } from 'src/components/common/MultiSelect';

/** Narrows picker ids back to readiness states, dropping anything else. */
export function toReadinessStates(ids: string[]): ReadinessState[] {
  return READINESS_STATES.filter((s) => ids.includes(s));
}

/**
 * Order-readiness picker options, in the Order column's words. React
 * Compiler caches the list, so no manual memo.
 */
export function useReadinessOptions(): MultiSelectOption[] {
  const gt = useGT();
  return READINESS_STATES.map((id) => ({
    id,
    label:
      id === 'ready'
        ? gt('Ready', { context: 'buying order readiness filter option' })
        : id === 'warning'
          ? gt('Warning', { context: 'buying order readiness filter option' })
          : gt('Not ready', {
              context: 'buying order readiness filter option',
            }),
  }));
}
